import { useEffect, useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useFeatureFlagUpdater } from "../contexts/FeatureFlagContext";

/**
 * This component reads URL parameters and updates the feature flags accordingly.
 * It must be used within a component that has access to React Router's context.
 */
export const FeatureFlagInitializer = () => {
  const [searchParams] = useSearchParams();
  const setFeatureFlags = useFeatureFlagUpdater();

  // Get the feature flag value once and memoize it
  const isPricingCalculatorEnabled = useMemo(() => {
    return searchParams.get("enablePricingCalculator") === "true";
  }, [searchParams]);

  // Use useCallback to memoize the feature flags object
  const updateFeatureFlags = useCallback(() => {
    setFeatureFlags({
      isPricingCalculatorEnabled,
    });
  }, [isPricingCalculatorEnabled, setFeatureFlags]);

  useEffect(() => {
    updateFeatureFlags();
  }, [updateFeatureFlags]);

  // This component doesn't render anything
  return null;
};
